import React from 'react';
import { motion } from 'framer-motion';

const ServicesHero = () => {
  return (
    <section className="relative min-h-[45vh] flex items-center justify-center pt-32">
      {/* Animated Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-black/90" />
        <div className="absolute inset-0">
          <div className="absolute inset-0 opacity-30">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_#1EB899_0%,_transparent_50%)]" />
          </div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.5 }}
            className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80')] bg-cover bg-center"
            style={{ filter: 'grayscale(100%) brightness(0.3)' }}
          />
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-h1 font-display font-semibold text-white mb-6 leading-[1.2]">
              Innovative. Scalable.<br />Future-Ready Solutions.
            </h1>
            <p className="text-lg md:text-xl text-gray-300 leading-[1.6]">
              Solutions21 delivers cutting-edge technology solutions that drive business transformation.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;